import { connect } from 'unistore/preact';
import { clientMessage, getKey } from '../../utils/common';
import { PAYMODE } from '../../../../common/src/constant';
import { RupeeSymbol } from '../rupeeSymbol/index';

const MiniCart = props => {
  const isEmiSubventionFlow = props.isEmiSubventionFlow;
  const locale = clientMessage(PAYMODE.EMI.toLowerCase(), props.cache);
  const { selectedPlan, cart, miniCart } = props;
  let cartItems = getKey(cart, 'cart_items', null);
  if (isEmiSubventionFlow && miniCart) {
    const itemBreakUp = getKey(selectedPlan, 'itemBreakUp', []);
    cartItems = miniCart.map(item => {
      itemBreakUp.forEach(i => {
        if (item.id === i.id) {
          const { gratifications, offerId } = i;
          const { effectivePrice, interval, interest, emi, finalTransactionAmount } = selectedPlan;
          item = {
            ...item,
            gratifications,
            offerId,
            effectivePrice,
            interval,
            emi,
            finalTransactionAmount,
            interest
          };
        }
      });
      return item;
    });
  }
  return (
    <div className={`ptm-plan-detail`}>
      <div className={`ptm-close-wrap ptm-pos-a ptm-closeIcon`}>
        <span className={`ptm-cross ptm-pos-r`} onClick={() => props.closeMiniCart()} />
      </div>
      {selectedPlan && (
        <div className={`ptm-emi-heading  ptm-w100-ib`}>
          <span className={`ptm-left`}> {selectedPlan.interval} Months EMI plan</span>
        </div>
      )}
      <p className={`ptm-light-txt`}>{locale.label.interest}</p>

      {cartItems &&
        cartItems.map(item => {
          const planId = selectedPlan.planId;
          let itemEmiOffer = getKey(item, `emi_offers.${planId}`, null);
          let gratification;
          if (isEmiSubventionFlow) {
            itemEmiOffer = item;
          }
          if (itemEmiOffer) {
            gratification = getKey(itemEmiOffer, 'gratifications', null);
          }
          if (gratification) {
            [gratification] = gratification;
          }
          return (
            <div className={`ptm-product-box prduct-box-global`}>
              <div className={`ptm-product-inner ptm-pos-r ptm-global-border`}>
                <img
                  src={item.image_url || item.image}
                  className={`ptm-product-img ptm-centralized ptm-pos-a`}
                  alt="product_img"
                />
                <p className={`ptm-product-detail`}>{item.name}</p>
                <p className={`ptm-quantity`}>
                  Qty: <span>{item.quantity}</span>
                </p>
              </div>
              <p className={`ptm-dscrpt-row ptm-w100-ib`}>
                <span className={`ptmleft`}>Item Value</span>
                <span className={`ptm-right`}>
                  <RupeeSymbol /> {item.total_price || item.finalTransactionAmount}
                </span>
              </p>
              <p className={`ptm-dscrpt-row ptm-w100-ib`}>
                <span className={`ptm-left`}>
                  Total Interest <span className={`ptm-charge-txt`}>(Charged by bank)</span>
                </span>
                <span className={`ptm-right`}>
                  + <RupeeSymbol /> {itemEmiOffer.interest}
                </span>
              </p>
              {itemEmiOffer && itemEmiOffer.gratifications && gratification && (
                <div className={`ptm-cashback-strip`}>
                  EMI {gratification.type.toLowerCase()}
                  <span className={`ptm-right`}>
                    {' '}
                    - <RupeeSymbol /> {gratification.value}
                  </span>
                </div>
              )}
              {gratification && gratification.type === 'CASHBACK' && (
                <p className={`ptm-light-txt`}>Cashback will be credited in your Paytm wallet</p>
              )}
              <p className={`ptm-effective-price ptm-w100-ib`}>
                <span className={`ptm-left`}>Effective Price</span>
                <span className={`ptm-right`}>
                  <RupeeSymbol /> {itemEmiOffer && itemEmiOffer.effectivePrice}
                </span>
              </p>
            </div>
          );
        })}
    </div>
  );
};

export default connect('cache')(MiniCart);



// WEBPACK FOOTER //
// ./components/miniCart/index.js